<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">企业文化</span>
    </navbar>
    <div class="page-content">
      <scroller ref="scroller" :on-infinite="loadMore">
        <div class="culture">
          <ul class="list-group">
            <router-link tag="li" :to="`/culture/article/${article.id}`" class="list-item clearfix" v-for="(article, index) in cultureArticles" :key="index">
              <div class="pull-left list-item-img">
                <img :src="article.bannerUrl" alt="article.title">
              </div>
              <div class="pull-right list-item-content">
                <h3>{{article.title}}</h3>
                <p class="indent">{{article.summary}}</p>
                <div class="time text-right">
                  {{article.addDate}}
                </div>
              </div>
            </router-link>
          </ul>
        </div>
      </scroller>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Scroller from 'components/scroller/scroller'
  export default {
    data () {
      return {
        cultureArticles: [],
        pageNumber: 0,
        pageSize: 10,
        hasmore: true
      }
    },
    created () {
//      this.getCultureArticles()
//      this.loadMore()
    },
    mounted () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.scroller.resize()
        }, 500)
      })
    },
    methods: {
      getCultureArticles () {
        let vm = this
        this.$ajax({
          url: '/getCorporateCultureArticles.jhtml',
          params: {
            isPage: 'y',
            pageNumber: this.pageNumber || 1,
            pageSize: this.pageSize
          },
          done (articles, page) {
            vm.pageNumber = page.pageNumber
            vm.hasmore = page.count > 0 && page.pageNumber * page.pageSize < page.count
            vm.cultureArticles = vm.cultureArticles.concat(articles)
          },
          fail (msg) {
            vm.$dialog(msg)
          },
          always () {
            vm.$refs.scroller.finishInfinite(true)
          }
        })
      },
      loadMore () {
        if (this.hasmore) {
          this.pageNumber++
          setTimeout(() => {
            this.getCultureArticles()
          }, 500)
        } else {
          this.$refs.scroller.finishInfinite(true)
        }
      }
    },
    components: {
      Navbar,
      Scroller
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .culture
    margin px2rem(28px) px2rem(20px) px2rem(28px)
    .list-group
      padding 0
      .list-item
        list-style none
        margin-bottom px2rem(28px)
        background-color rgba(255, 255, 255, 1)
        border-radius px2rem(4px)
        overflow hidden
        box-shadow 0 10px 30px 0 rgba(188, 200, 209, 1)
        &::after,
        &::before
          content ''
          display block
          height 0
          line-height 0
          overflow hidden
          clear both
        &:last-child
          margin-bottom 0
      .list-item-img
        width px2rem(230px)
        height px2rem(230px)
        overflow hidden
        position relative
        img
          max-width none !important
          position absolute
          left 50%
          top 0
          transform translateX(-50%)
          -webkit-transform translateX(-50%)
          height px2rem(230px)
      .list-item-content
        width px2rem(480px)
        height px2rem(230px)
        padding px2rem(20px) px2rem(22px) px2rem(20px) px2rem(40px)
        box-sizing border-box
      h3
        height px2rem(34px)
        line-height px2rem(34px)
        font-size px2rem(28)
        ellipsis()
        margin-top 0
        margin-bottom px2rem(10px)
      .indent
        margin 0
        text-indent 2em
        font-size px2rem(24px)
        color #97a1aa
        line-height px2rem(36px)
        height px2rem(108px)
        overflow hidden
      .time
        color #97a1aa
        margin-top px2rem(14px)
</style>



// WEBPACK FOOTER //
// culture.vue?f192da3a